import { createSelector } from 'reselect';
import { v2 } from '@saucelabs/sl-module-builds';

import { eventMetaDataSelector } from '../common/selectors';

const selectSlice = (store) => store.apps.jobs.flatBuilds.vdc;

export const selectBuilds = v2.buildsList.selectors.createBuildListSelector(selectSlice);

export const automatedBuildsSelector = createSelector([
  (store) => store.apps.jobs.flatBuilds.common,
  selectSlice,
  selectBuilds,
  eventMetaDataSelector,
],
(common, slice, builds, eventMetaData) => ({
  buildsLoading: common.get('vdcBuildsLoading'),
  builds,
  expandedBuilds: slice.get('expandedBuilds'),
  failedJobs: slice.get('failedJobs'),
  eventMetaData: {
    ...eventMetaData,
    sku_type: 'VDC',
  },
}));

export const getUsername = v2.buildsList.selectors.createGetUsername(selectSlice);
